import { render, staticRenderFns } from "./Add_admin.vue?vue&type=template&id=6396754a&"
import script from "./Add_admin.vue?vue&type=script&lang=js&"
export * from "./Add_admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports